<template>
  <section id="products" class="ec-section products">
    <div class="ec-container">
      <header class="products__head">
        <span class="ec-eyebrow" v-reveal>{{ $t('products.eyebrow') }}</span>
        <h2 class="ec-title" v-reveal="60">{{ $t('products.titlePre') }}<span class="ec-gradient-text">{{ $t('products.titleHi') }}</span></h2>
        <p class="ec-lead" v-reveal="120">{{ $t('products.lead') }}</p>
      </header>

      <div class="products__grid">
        <article
          v-for="(p, i) in products"
          :key="p.title"
          class="pcard"
          :class="{ 'pcard--feature': p.feature }"
          v-reveal="i * 70"
        >
          <div class="pcard__icon" :style="{ background: p.grad }">
            <span v-html="p.icon"></span>
          </div>
          <h3 class="pcard__title">{{ p.title }}</h3>
          <p class="pcard__desc">{{ p.desc }}</p>
          <ul class="pcard__list">
            <li v-for="f in p.features" :key="f">{{ f }}</li>
          </ul>
          <a href="#contact" class="pcard__link">{{ $t('products.detailLink') }}</a>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
// Visual attributes stay here; localized text comes from i18n and is merged by index.
const META = [
  { grad: 'linear-gradient(135deg,#FF9900,#FF6F00)', icon: '🚀', feature: true },
  { grad: 'linear-gradient(135deg,#232F3E,#FF9900)', icon: '🛡️' },
  { grad: 'linear-gradient(135deg,#FF9900,#FFB84D)', icon: '⚙️', feature: true },
  { grad: 'linear-gradient(135deg,#232F3E,#527FFF)', icon: '🖧️' },
  { grad: 'linear-gradient(135deg,#527FFF,#232F3E)', icon: '📊' },
  { grad: 'linear-gradient(135deg,#FF6F00,#FF9900)', icon: '💼' }
]

export default {
  name: 'ProductsSection',
  computed: {
    products() {
      return this.$tm('products.items').map((item, i) => ({ ...META[i], ...item }))
    }
  }
}
</script>

<style scoped>
.products__head { text-align: center; display: flex; flex-direction: column; align-items: center; margin-bottom: 64px; }
.products__head .ec-lead { margin-top: 4px; }

.products__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }

.pcard {
  position: relative; padding: 32px 28px;
  background: var(--ec-card); border: 1px solid var(--ec-line);
  border-radius: var(--ec-radius); overflow: hidden;
  transition: transform .35s ease, border-color .35s ease, background .35s ease;
}
.pcard::before {
  content: ""; position: absolute; inset: 0;
  background: radial-gradient(420px circle at top right, rgba(255,153,0,.14), transparent 60%);
  opacity: 0; transition: opacity .4s ease;
}
.pcard:hover { transform: translateY(-6px); border-color: rgba(255,153,0,.4); background: var(--ec-card-2); }
.pcard:hover::before { opacity: 1; }
.pcard--feature { background: linear-gradient(165deg, rgba(255,153,0,.1), rgba(255,111,0,.06)); border-color: rgba(255,153,0,.28); }

.pcard__icon { width: 56px; height: 56px; border-radius: 16px; display: grid; place-items: center; font-size: 26px; margin-bottom: 20px; box-shadow: 0 12px 30px -12px rgba(255,153,0,.55); }
.pcard__title { font-size: 21px; margin-bottom: 10px; }
.pcard__desc { color: var(--ec-text-soft); font-size: 15px; margin-bottom: 18px; min-height: 48px; }
.pcard__list { list-style: none; padding: 0; margin: 0 0 22px; display: flex; flex-direction: column; gap: 9px; }
.pcard__list li { font-size: 14px; color: var(--ec-text-soft); padding-left: 24px; position: relative; }
.pcard__list li::before { content: "✓"; position: absolute; left: 0; top: 0; color: var(--ec-cyan); font-weight: 800; }
.pcard__link { position: relative; font-size: 14px; font-weight: 600; color: var(--ec-cyan); transition: gap .2s ease; }
.pcard__link:hover { letter-spacing: .01em; }

@media (max-width: 900px) { .products__grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) { .products__grid { grid-template-columns: 1fr; } .pcard__desc { min-height: 0; } }
</style>
